document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener(
    'submit',
    function (event) {

      const form = event.target;
      const productForm = form.closest('product-form');
      if (!productForm) return;

      if (form.dataset.type !== 'add-to-cart-form-printer') return;

      const softwarePlanId = form.getAttribute('software_selling_plan');
      if (!softwarePlanId) return;

      const softwareVariantId = form.getAttribute('software_variant_id');
      if (!softwareVariantId) return;


      const quantityInput =
        form.querySelector('input[name="quantity"]');

      const quantity = quantityInput
        ? quantityInput.value
        : 1;

      // 💻 Add Software as items[1]

      const idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'items[1][id]';
      idInput.value = softwareVariantId;
      idInput.dataset.softwareItem = 'true';

      const planInput = document.createElement('input');
      planInput.type = 'hidden';
      planInput.name = 'items[1][selling_plan]';
      planInput.value = softwarePlanId;
      planInput.dataset.softwareItem = 'true';

      const qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'items[1][quantity]';
      qtyInput.value = quantity;
      qtyInput.dataset.softwareItem = 'true';

      form.appendChild(idInput);
      form.appendChild(planInput);
      form.appendChild(qtyInput);

    },
    true // 🔴 Capture phase required for Dawn
  );

});
